import { Component, OnInit } from '@angular/core';
import { HomeUrlHelper } from '@sc/pas-common';

@Component({
    templateUrl: './renovations.component.html',
    styleUrls: ['./renovations.component.scss'],
})

export class RenovationsComponent implements OnInit {

    origin: string = 'LEGACY_BASE';
    url: string = 'PortalSCNet/PortalPas/AccesoAPortalPas.aspx?Destino=Renovaciones';
    mode: string = 'EMBEDDED';
    token: string = 'NUEVO_PORTAL_TOKEN';
    iframeUrl: string;
    urlLoaded : boolean = false;

    constructor(private _urlHelper: HomeUrlHelper) {}

    ngOnInit() {
        const fullUrl = this._urlHelper.urlByOrigin(this.url, this.origin);
        this._urlHelper.addTokenUrlItem(fullUrl, this.token).subscribe(
            urlParsed => {
                this.iframeUrl = urlParsed;
                this.urlLoaded = false;
            }
        );
    }

    onLoaded(event) {
        this.urlLoaded = true;
    }
}
